import type { NonEmptyArray } from "~/tools/non-empty-array";

export function generateVariableNames(name: string): NonEmptyArray<string> {
	return [name, `vars.${name}`];
}
